const PLATFORMS = {
  twitter: {
    base: "https://x.com/",
    hosts: ["x.com", "twitter.com"],
    handlePath: /^\/([A-Za-z0-9._-]+)\/?$/,
    reservedSegments: [
      "i", "search", "home", "explore", "notifications",
      "messages", "settings", "login", "signup", "compose", "logout",
    ],
    stripLeadingAt: true,
  },
  instagram: {
    base: "https://instagram.com/",
    hosts: ["instagram.com"],
    handlePath: /^\/([A-Za-z0-9._-]+)\/?$/,
    reservedSegments: [
      "explore", "reels", "p", "tv", "accounts",
      "about", "developer", "directory",
    ],
    stripLeadingAt: true,
  },
  tiktok: {
    base: "https://tiktok.com/@",
    hosts: ["tiktok.com"],
    handlePath: /^\/@([A-Za-z0-9._-]+)\/?$/,
    reservedSegments: [],
    stripLeadingAt: true,
  },
  facebook: {
    base: "https://facebook.com/",
    hosts: ["facebook.com"],
    handlePath: /^\/([A-Za-z0-9._-]+)\/?$/,
    reservedSegments: [
      "profile.php", "people", "pages", "groups", "events",
      "watch", "marketplace", "gaming", "business", "messages",
    ],
    stripLeadingAt: true,
  },
  youtube: {
    base: "https://youtube.com/@",
    hosts: ["youtube.com"],
    handlePath: /^\/@([A-Za-z0-9._-]+)\/?$/,
    reservedSegments: [],
    stripLeadingAt: true,
  },
};

// Accepts a bare handle ("ekitabu"), an @handle ("@ekitabu"), or a full URL.
// Returns a navigable URL, or null when the handle is empty.
export function resolveSocialUrl(platform, handle) {
  if (!handle) return null;
  const trimmed = String(handle).trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const config = PLATFORMS[platform];
  if (!config) return null;

  const value = config.stripLeadingAt ? trimmed.replace(/^@+/, "") : trimmed;
  return `${config.base}${value}`;
}

// Accepts a bare handle ("ekitabu"), an @handle ("@ekitabu"), or a full URL
// (e.g. "https://www.facebook.com/ekitabu/"). Returns the bare handle
// stripped of leading "@" and surrounding slashes. Returns null when the
// input is a URL we can't parse a handle from.
export function extractSocialHandle(platform, input) {
  if (!input) return "";
  const trimmed = String(input).trim();
  if (!trimmed) return "";

  if (!/^https?:\/\//i.test(trimmed)) {
    return trimmed.replace(/^@+/, "");
  }

  const config = PLATFORMS[platform];
  if (!config) return null;

  let url;
  try {
    url = new URL(trimmed);
  } catch {
    return null;
  }

  // Strip leading "www." only. Mobile subdomains (m.*) are intentionally
  // rejected so users provide the canonical URL.
  const host = url.hostname.replace(/^www\./, "");
  if (!config.hosts.includes(host)) return null;

  const match = url.pathname.match(config.handlePath);
  if (!match) return null;

  const candidate = match[1];
  if (config.reservedSegments?.includes(candidate)) return null;

  return candidate;
}
